export class DepositPayment {
    constructor(
        public id: string,
        public amount: number,
        public currencyCode: string,
        public partySize: number,
        public paymentIntentId: string | null,
        public dateCreated: Date,
        public dateRefunded: Date | null,
        public amountRefunded: number = 0
    ) { }

    amountRefundable(): number {
        return Math.max(0, this.amount - this.refundedAmount())
    }

    refundedAmount(): number {
        if (this.amountRefunded > 0) {
            return this.amountRefunded
        }
        if (this.dateRefunded !== null) {
            return this.amount
        }
        return 0
    }
}
